import { appURLs } from "@/app/constants.mjs";
import {
  DeleteBlitzUser,
  GetActiveSessions,
  GetRoles,
  RemoveActiveSession,
} from "@/feature-auth/fetches/user-client-gql.mjs";
import * as GQLClient from "@/feature-auth/fetches/user-client-gql.mjs";
import * as GQL from "@/feature-auth/fetches/user-preferences-client-gql.mjs";
import { postGQL, queryGQL } from "@/util/gql-formatters.mjs";

export function getUserMarketingEmailOptIn(userId: string) {
  return queryGQL(appURLs.CMS, GQL.UserMarketingEmailOptIn, { userId });
}

export function setUserMarketingEmailOptIn(optedIn: boolean) {
  return postGQL(appURLs.CMS, GQL.UpdateUserMarketingEmailOptIn, { optedIn });
}

export function getUserRoles() {
  return queryGQL(appURLs.AUTH_GRAPHQL, GetRoles, {});
}

export function getActiveSessions() {
  return queryGQL(appURLs.AUTH_GRAPHQL, GetActiveSessions, {});
}

export function removeActiveSession(sessionTrackerIds: string[]) {
  return postGQL(appURLs.AUTH_GRAPHQL, RemoveActiveSession, {
    sessionTrackerIds,
  });
}

export function removeBlitzUser() {
  return postGQL(appURLs.AUTH_GRAPHQL, DeleteBlitzUser, {});
}

export function getIsEmailTaken(email: string) {
  return queryGQL(appURLs.AUTH_GRAPHQL, GQLClient.isEmailTaken, { email });
}

export function getOAuth2Url(provider: string, trackerId: string) {
  return appURLs.AUTH + "/oauth/" + provider + "?tracker_id=" + trackerId;
}
